'use strict'

import React, { PropTypes } from 'react'
import Modal from '../assets/modal'

export default class Agreement extends React.Component {
  constructor () {
    super()

    this.state = {
      modalOpened: false
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal () {
    this.setState({ modalOpened: true })
  }

  closeModal () {
    this.setState({ modalOpened: false })
  }

  updateAgreement (e) {
    const { onChange } = this.props

    if (e.target.checked) {
      onChange('agreement', {
        value: e.target.checked,
        pageRef: 'book-your-appointment',
        order: 11
      })
    } else {
      onChange('agreement', undefined)
    }
  }

  termsAndConditions () {
    const { termsAndConditions } = this.context
    return (
      <div>
        <p>
          The following terms and conditions applies to all Dental Vouchers.
        </p>
        <ol>
          { termsAndConditions.map((termOrCondition, key) => <li key={key}>{termOrCondition}</li>) }
        </ol>
      </div>
    )
  }

  render () {
    const { modalOpened } = this.state

    return (
      <section className='terms-section no-background'>
        <input type='checkbox' id='terms-agreement' onChange={this.updateAgreement.bind(this)} />
        <label htmlFor='terms-agreement'>
          I have read and I understand and agree to the
          <b><span className='text-deco-none hover-opacity primary-color-text pointer' onClick={this.openModal}> terms and conditions</span></b> governing the debit
          arrangements between myself and Dental Members Australia Pty Ltd (User ID 415095) as set out in this request.
        </label>
        <Modal
          title='Terms & Conditions'
          content={this.termsAndConditions()}
          opened={modalOpened}
          onClose={this.closeModal} />
      </section>
    )
  }
}

Agreement.contextTypes = {
  termsAndConditions: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/form-segments/agreement.js